export default {
  count: 0,
  totalAmount: 0,
  currencyCode: null
}



// WEBPACK FOOTER //
// ./src/components/_modules/Payment/models/snapshot-model.js